<template>
  <el-dialog
    :title="title"
    :visible.sync="xzVisible"
    :close-on-click-modal="false"
    width="80%"
    center
    :before-close="closeadd"
  >
  <div class="topForm">
    <el-form
      :model="FormData"
      ref="FormData"
      class="demo-dynamic"
      :rules="Rules"
      :inline="true"
    >
      <el-form-item prop="instockPlateNumber" label="车号:">
        <el-input v-model="FormData.instockPlateNumber" placeholder="请输入车号"  size="mini"></el-input>
      </el-form-item>
      <el-form-item prop="primaryCustomerTaxId"  label="一级货主:">
        <el-select v-model="FormData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable :disabled='disYiJi'>
          <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="customerTaxId"  label="二级货主:">
        <el-select v-model="FormData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable :disabled='disErJi'>
          <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber" ></el-option>
        </el-select>
      </el-form-item>
       <el-form-item prop="arrivalMethod" label="到货方式:">
        <el-select v-model="FormData.arrivalMethod" clearable placeholder="请选择" filterable size="mini" :disabled='disArrivalMethod'>
          <el-option
            v-for="(item, index) in arrivalMethodData"
            :key="index"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
       <el-form-item prop="ext1" label="备注:">
        <el-input v-model="FormData.ext1" placeholder="请输入备注" size="mini" :maxlength='50' type="textarea"></el-input>
      </el-form-item>
    </el-form>
     </div>
     <div class="bottomTable">
      <div class="detailsTitle">
        <h4>货物信息</h4>
        <el-button style="position:absolute;left:110px;" type="primary" @click="addtable" v-if="addBtnShow">新增</el-button>
      </div>
      <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableref" :data="table" style="width: 100%" class="elTab">
       <el-table-column prop="productType" label="货物类型" align="center" >
        <template slot-scope="scope1">
         <el-select filterable clearable v-model="scope1.row.productType" :disabled='title == "修改入库计划"' size="mini" placeholder="请选择货物类型" @change="selectProductType(scope1.row)" >
          <el-option v-for="(item,index) in huowuOptions" :key="index" :label="item.name" :value="item.id"></el-option>
         </el-select>
        </template>
       </el-table-column>
       <el-table-column prop="steelMillName" label="产地" align="center" >
        <template slot-scope="scope1">
         <el-select filterable clearable v-model="scope1.row.steelMillName" size="mini" placeholder="请选择产地" :disabled="scope1.row.disChandi" @change="selectChandi(scope1.row)">
          <el-option v-for="(item,index) in scope1.row.chanDiOptions" :key="index" :label="item" :value="item"></el-option>
         </el-select>
        </template>
       </el-table-column>
       <el-table-column prop="specification" label="规格" align="center" >
        <template slot-scope="scope1">
         <el-select filterable clearable v-model="scope1.row.specification" size="mini" placeholder="请选择规格" :disabled="scope1.row.disGuige" @change="selectGuige(scope1.row)">
          <el-option v-for="(item,index) in scope1.row.guigeOptions" :key="index" :label="item" :value="item"></el-option>
         </el-select>
        </template>
       </el-table-column>
       <el-table-column prop="model" label="材质" align="center" >
        <template slot-scope="scope1">
         <el-select filterable clearable v-model="scope1.row.model" size="mini" placeholder="请选择材质" :disabled="scope1.row.disCaizhi" @change="selectCaizhi(scope1.row)">
          <el-option v-for="(item,index) in scope1.row.caizhiOptions" :key="index" :label="item" :value="item"></el-option>
         </el-select>
        </template>
       </el-table-column>
       <el-table-column prop="number" label="件数" align="center" >
        <template slot-scope="scope1">
          <el-input v-model="scope1.row.number" v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini" :disabled="scope1.row.disJianshu" @input="NumberInput(scope1.row)"></el-input>
        </template>
       </el-table-column>
       <el-table-column prop="weight" label="理重(吨)" align="center" >
        <template slot-scope="scope1">
          <el-input v-model="scope1.row.weight" v-number-input.float="4" maxlength="50" placeholder="请输入理重(吨)" size="mini" :disabled="scope1.row.disLizhong"></el-input>
        </template>
       </el-table-column>
       <el-table-column prop="factoryWeight" label="出厂过磅净重(吨)" align="center" >
        <template slot-scope="scope1">
          <el-input v-model="scope1.row.factoryWeight" v-number-input.float="4"  maxlength="50" placeholder="请输入出厂过磅净重(吨)" size="mini" :disabled="scope1.row.disGbjz"></el-input>
        </template>
       </el-table-column>
       <el-table-column prop="" label="编辑" align="center" >
        <template slot-scope="scope1">
          <el-button @click="delClick(scope1.$index, scope1.row)" type="text" size="small">删除</el-button>
        </template>
       </el-table-column>
      </el-table>
     </div>
    <div slot="footer" style=" margin: 15px auto">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="Loading" @click="addDialog">保 存</el-button>
      <el-button type="primary" :loading="saveLoading" @click="addDialogPrint">保存并打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getVirtualBalingList,
  getWeighingMethodList } from '@/api/wms-stock'
import {
  createInstockPlan, // 新增
  updateInstockPlan // 修改
} from '@/api/wms-access'
var validateInt = (rule, value, callback) => {
  if (value == 0) {
    callback(new Error('件数不能为0'))
  } else {
    callback()
  }
}
export default {
  name: 'rukuPlanDialog',
  data () {
    return {
      validateInt: validateInt,
      FormData: {
        instockPlateNumber: '',
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerTaxId: '',
        customerName: '',
        arrivalMethod: '',
        ext1: ''
      },
      Rules: {
        instockPlateNumber: [
          { required: true, message: '请输入车号', trigger: 'blur' }
        ],
        primaryCustomerTaxId: [
          { required: true, message: '请选择一级货主', trigger: 'change' }
        ],
        customerTaxId: [
          { required: true, message: '请选择二级货主', trigger: 'change' }
        ],
        arrivalMethod: [
          { required: true, message: '请选择到货方式', trigger: 'blur' }
        ],
        ext1: [
          { required: false, message: '请输入备注', trigger: 'blur' }
        ]
      },
      // RKData: [],
      table: [],
      Loading: false,
      chanDiOptions: [],
      huowuOptions: [],
      guigeOptions: [],
      caizhiOptions: [],
      saveLoading: false,
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      delSummaryIdList: [],
      disYiJi: false,
      disErJi: false,
      disArrivalMethod: false,
      addBtnShow: true
    }
  },
  props: {
    title: {
      type: String,
      default: '新增入库计划'
    },
    xzVisible: {
      type: Boolean,
      default: false
    },
    xztableData: {
      type: Array
    },
    xiugaiObj: {
      type: Object
    },
    RKData: {
      type: Array
    }
  },
  watch: {
    xztableData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length == 0) {
          this.table = []
          let obj = {
            steelMillName: '',
            productType: '',
            specification: '',
            model: '',
            number: '',
            weight: '',
            factoryWeight: '',
            disChandi: true,
            disGuige: true,
            disCaizhi: true,
            disJianshu: true,
            disLizhong: true,
            disGbjz: true,
            chanDiOptions: [],
            huowuOptions: [],
            guigeOptions: [],
            caizhiOptions: []
          }
          this.table.push(obj)
        } else {
          let hwInfos = JSON.parse(window.localStorage.getItem('HwInfos'))
          val.map(item => {
            item.disLizhong = true
          })
          this.table = JSON.parse(JSON.stringify(val))
          this.table.map(item => this.getOptions(item, hwInfos))
        }
      }
    },
    xiugaiObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.FormData.instockPlateNumber = val.instockPlateNumber
          this.FormData.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.FormData.customerTaxId = val.customerTaxId
          this.FormData.arrivalMethod = val.arrivalMethod
          this.FormData.ext1 = val.ext1
        }
      }
    }
  },
  methods: {
    getOptions (row, hwInfos) {
      this.$set(row, 'chanDiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType).map(item => item.placeOfOrigin))))
      this.$set(row, 'guigeOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType && item.placeOfOrigin == row.steelMillName).map(item => item.specification))))
      this.$set(row, 'caizhiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType && item.placeOfOrigin == row.steelMillName && item.specification == row.specification).map(item => item.model))))
    },
    closeadd () {
      this.$emit('update:xzVisible', false)
      this.$parent.xztableData = []
      this.$parent.xiugaiObj = {}
    },
    addDialog () {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          if (this.table.length == 0) {
            this.$message({ message: '请添加货物信息', type: 'error' })
          } else {
            this.Loading = true
            this.FormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.primaryCustomerTaxId)[0].custerName
            this.FormData.customerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.customerTaxId)[0].custerName
            for (let i = 0; i < this.table.length; i++) {
              if (this.table[i].inWeighingMethod == 3 && this.table[i].factoryWeight / 1 == 0) {
                this.$message({ message: '请填写出厂过磅净重', type: 'error' })
                this.Loading = false
                return
              } else if (this.table[i].number / 1 == 0) {
                this.$message({ message: '件数不能为空或0', type: 'error' })
                this.Loading = false
                return
              }
            }
            let subTable = this.table.filter(item => item.number != 0)
            if (this.title == '修改入库计划') {
              this.FormData.instockId = this.xiugaiObj.instockId
              updateInstockPlan(
                { master: this.FormData, updateSummaryList: subTable, delSummaryIdList: this.delSummaryIdList }
              )
                .then(res => {
                  this.$message({ message: '成功', type: 'success' })
                  this.$parent.chaxun()
                  this.delSummaryIdList = []
                  this.$parent.xztableData = []
                  this.$parent.xiugaiObj = {}
                  this.$emit('update:xzVisible', false)
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                  this.Loading = false
                })
            } else {
              createInstockPlan(
                { ...this.FormData, tInstockSummaryList: subTable }
              )
                .then(res => {
                  this.$message({ message: '成功', type: 'success' })
                  this.$parent.chaxun()
                  this.$parent.xztableData = []
                  this.$parent.xiugaiObj = {}
                  this.$emit('update:xzVisible', false)
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                  this.Loading = false
                })
            }
          }
        } else {
        }
      })
    },
    addDialogPrint () {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          if (this.table.length == 0) {
            this.$message({ message: '请添加货物信息', type: 'error' })
          } else {
            this.saveLoading = true
            this.FormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.primaryCustomerTaxId)[0].custerName
            this.FormData.customerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.customerTaxId)[0].custerName
            for (let i = 0; i < this.table.length; i++) {
              if (this.table[i].inWeighingMethod == 3 && this.table[i].factoryWeight == '') {
                this.$message({ message: '请填写出厂过磅净重', type: 'error' })
                this.saveLoading = false
                return
              }
            }
            let subTable = this.table.filter(item => item.number != 0)
            if (this.title == '修改入库计划') {
              this.FormData.instockId = this.xiugaiObj.instockId
              updateInstockPlan(
                { master: this.FormData, updateSummaryList: subTable, delSummaryIdList: this.delSummaryIdList }
              )
                .then(res => {
                  this.$message({ message: '成功', type: 'success' })
                  this.$parent.xztableData = []
                  this.delSummaryIdList = []
                  this.$parent.xiugaiObj = {}
                  this.$emit('update:xzVisible', false)
                  this.$router.push({
                    path: '/yycXieCheDan',
                    query: {
                      id: res
                    }
                  })
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                  this.saveLoading = false
                })
            } else {
              createInstockPlan(
                { ...this.FormData, tInstockSummaryList: subTable }
              )
                .then(res => {
                  this.$message({ message: '成功', type: 'success' })
                  this.$parent.xztableData = []
                  this.$parent.xiugaiObj = {}
                  this.$emit('update:xzVisible', false)
                  this.$router.push({
                    path: '/yycXieCheDan',
                    query: {
                      id: res
                    }
                  })
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                  this.saveLoading = false
                })
            }
          }
        } else {

        }
      })
    },
    delClick (index, row) {
      if (this.title == '修改入库计划') {
        this.delSummaryIdList.push(row.instockSummaryId)
        this.delSummaryIdList = Array.from(new Set(this.delSummaryIdList))
        this.table.splice(index, 1)
      } else {
        this.table.splice(index, 1)
      }
    },
    addtable () {
      let obj = {
        steelMillName: '',
        productType: '',
        productTypeName: '',
        specification: '',
        model: '',
        number: '',
        weight: '',
        factoryWeight: '',
        disChandi: true,
        disGuige: true,
        disCaizhi: true,
        disJianshu: true,
        disLizhong: true,
        disGbjz: true,
        chanDiOptions: [],
        huowuOptions: [],
        guigeOptions: [],
        caizhiOptions: []
      }
      this.table.push(obj)
    },
    getVirtualBalingLists () {
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          window.localStorage.setItem('HwInfos', JSON.stringify(res))
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.huowuOptions = arrNew
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    selectProductType (row) {
      row.disChandi = false
      row.disGuige = true
      row.disCaizhi = true
      row.disJianshu = true
      row.disJianshu = true
      row.disGbjz = true
      row.steelMillName = ''
      row.specification = ''
      row.model = ''
      row.number = ''
      row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''
      row.chanDiOptions = []
      row.guigeOptions = []
      row.caizhiOptions = []
      row.productTypeName = this.huowuOptions.filter(item => item.id == row.productType)[0].name
      getWeighingMethodList({
        productType: row.productType
      })
        .then(res => {
          if (res.length > 0) {
            row.inWeighingMethod = res[0].inWeighingMethod
            if (row.productType != '') {
              getVirtualBalingList({ ...row })
                .then(res => {
                  row.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                })
            }
          } else {
            this.$message({ message: '计重方式未配置，请联系管理员', type: 'error' })
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    selectChandi (row) {
      row.disGuige = false
      row.disCaizhi = true
      row.disJianshu = true
      row.disJianshu = true
      row.disGbjz = true
      row.specification = ''
      row.model = ''
      row.number = ''
      row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''
      row.guigeOptions = []
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName
      if (row.steelMillName != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectGuige (row) {
      row.disCaizhi = false
      row.disJianshu = true
      row.disGbjz = true
      row.model = ''
      row.number = ''
      row.weight = ''
      row.singletonWeight = ''
      row.factoryWeight = ''
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName
      if (row.specification != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectCaizhi (row) {
      row.disJianshu = false
      row.disGbjz = true
      row.number = ''
      row.weight = ''
      row.placeOfOrigin = row.steelMillName
      row.factoryWeight = ''
      row.singletonWeight = ''
      getVirtualBalingList({ ...row })
        .then(res => {
          row.singletonWeight = res[0].weight
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    NumberInput (row) {
      row.disGbjz = false
      row.weight = (row.number / 1 * row.singletonWeight).toFixed(4)
    }
  },
  created () {
    this.getVirtualBalingLists()
    console.log(this.title)
    if (this.title == '修改入库计划') {
      this.disYiJi = true
      this.disErJi = true
      this.disArrivalMethod = true
      this.addBtnShow = false
      this.table.forEach(item => {
        item.disChandi = true
        item.disGuige = true
        item.disCaizhi = true
      })
    } else {
      this.disYiJi = false
      this.disErJi = false
      this.disArrivalMethod = false
      this.addBtnShow = true
    }
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.addDialogPrint()
      }
    }
  },
  mounted () {
  }

}
</script>

<style>

</style>
